import { memo } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@/components/Icons';
import { Button, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { DateFormatUtil } from '@/utils';
import useStyles from '../styles';
import { IDatePeriodChangerProps } from '../types';

export default memo(function YearChanger({
  setPrevDate,
  setNextDate,
  date,
  ...rest
}: IDatePeriodChangerProps): JSX.Element {
  const classes = useStyles();

  return (
    <div {...rest} className={classes.datePeriodBlock}>
      <Button className={classes.chevronIcon} onClick={setPrevDate}>
        <ChevronLeftIcon className={clsx(classes.arrowButtonLeft, classes.arrowButton)} />
      </Button>
      <Typography className={classes.datePeriodData}>{date}</Typography>
      <Button
        className={classes.chevronIcon}
        disabled={date === DateFormatUtil.formatToYearNumber(new Date())}
        onClick={setNextDate}
      >
        <ChevronRightIcon className={clsx(classes.arrowButtonRight, classes.arrowButton)} />
      </Button>
    </div>
  );
});
